// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__118H5","itemTitle":"ClientEmergencyInfo_itemTitle__3AFQe","itemText":"ClientEmergencyInfo_itemText__2tYbz"};